<template>
  <reg-card>
    <div class="card-icon">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="#ff825d"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
    </div>

    <div v-if="loading" class="loading">A carregar planos…</div>

    <template v-else>
      <div class="plan-tabs">
        <button
          v-for="p in planos" :key="p.id"
          class="plan-tab"
          :class="{ active: selecionado === p.id }"
          @click="selecionado = p.id"
        >
          {{ p.nome }}
        </button>
      </div>

      <template v-if="planoAtual">
        <h2 class="title">{{ planoAtual.nome }}</h2>
        <p class="price">{{ planoAtual.preco_mensal }}€<span>/mês</span></p>
        <p class="cartoes-hint">Inclui {{ planoAtual.cartoes_incluidos.toLocaleString("pt-PT") }} cartões + notificações</p>
        <ul class="features">
          <li v-for="(f, i) in planoAtual.features" :key="i">{{ f }}</li>
        </ul>
      </template>
    </template>

    <button class="btn-dark" :disabled="!selecionado" @click="$emit('done', selecionado)">AVANÇAR</button>
  </reg-card>
</template>

<script>
import RegCard from "../components/RegCard.vue";

export default {
  name: "OStep1",
  components: { RegCard },
  props: {
    planos:  { type: Array,  default: () => [] },
    loading: { type: Boolean, default: false },
    value:   { default: null },
  },
  data() {
    return { selecionado: this.value || null };
  },
  computed: {
    planoAtual() {
      return this.planos.find(p => p.id === this.selecionado) || this.planos[0] || null;
    },
  },
  watch: {
    planos(val) {
      if (val.length && !this.selecionado) this.selecionado = val[0].id;
    },
  },
};
</script>

<style scoped lang="scss">
.card-icon { width: 36px; height: 36px; background: #fff5f0; border-radius: 10px; display: flex; align-items: center; justify-content: center; margin-bottom: 12px; }
.loading   { text-align: center; color: #b0a8a0; padding: 24px 0; font-size: 14px; }
.plan-tabs { display: flex; gap: 6px; margin-bottom: 16px; }
.plan-tab  {
  flex: 1; padding: 8px; border: 1.5px solid #e8e4e0; border-radius: 9px; background: #fff;
  font-size: 13px; font-weight: 600; color: #7a736e; cursor: pointer; font-family: inherit; transition: all .15s;
  &.active { border-color: #ff825d; background: #fff5f0; color: #ff825d; }
  &:hover:not(.active) { border-color: #c8c0b8; }
}
.title { font-size: 22px; font-weight: 800; color: #1a1210; margin-bottom: 4px; }
.price { font-size: 26px; font-weight: 800; color: #ff825d; margin-bottom: 2px; span { font-size: 14px; font-weight: 500; color: #b0a8a0; } }
.cartoes-hint { font-size: 12px; color: #b0a8a0; margin-bottom: 14px; }
.features { list-style: none; padding: 0; margin: 0 0 16px; li { padding: 10px 0; border-bottom: 1px solid #f5f2ef; font-size: 13.5px; color: #3a3430; &:last-child { border-bottom: none; } } }
.btn-dark { display: flex; align-items: center; justify-content: center; width: 100%; height: 50px; border: none; border-radius: 10px; background: #1a1210; color: #fff; font-size: 14px; font-weight: 700; cursor: pointer; font-family: inherit; &:hover:not(:disabled) { background: #2d2420; } &:disabled { opacity: .55; cursor: default; } }
</style>
